import { createController } from './createController';
import allActions from '../applications/main/actions/index';
import { createMainStateDomainWrapper } from '../applications/main/domain/createMainStateDomainWrapper';
import { withDomain } from '../applications/main/domain/DomainHOC';

export function createMainController(Component, shouldFetch) {
  return createController(withDomain(Component), createMainStateDomainWrapper, { ...allActions }, shouldFetch);
}
